export const normalizePolicyKind = (policyKind) =>
  policyKind === 'lsa' ? 'psa' : policyKind;
